import { MedosClient } from "../client/MedosClient";
const VALID_SOURCES = new Set([
    "MEDOS_APP_ANDROID",
    "MEDOS_APP_IOS",
    "MEDOS_WEBSITE",
    "SDK_POWERED_WEBSITE",
    "DEVELOPER_API",
    "PUBLIC_QR",
]);
const VALID_PAYMENT_MODES = new Set([
    "CASH",
    "CARD",
    "UPI",
    "BANK_TRANSFER",
    "ONLINE",
]);
function toMedosBookingRequest(p) {
    if (p.patientId === undefined && !p.patientPayload) {
        throw new Error("QMS booking requires either 'patientId' (existing patient) or 'patientPayload' (new patient)");
    }
    const source = p.source === "MEDOS_WEB"
        ? "MEDOS_WEBSITE"
        : p.source && VALID_SOURCES.has(p.source)
            ? p.source
            : "SDK_POWERED_WEBSITE";
    const paymentMode = p.paymentMode && VALID_PAYMENT_MODES.has(p.paymentMode)
        ? p.paymentMode
        : undefined;
    const request = {
        workspaceId: p.workspaceId,
        addressId: p.addressId,
        doctorId: p.doctorId,
        patientId: p.patientId,
        patientPayload: p.patientPayload,
        qmsWorkShiftId: p.qmsWorkShiftId,
        appointmentDate: p.appointmentDate,
        mode: p.mode,
        bookingChannel: p.bookingChannel ?? "SELF_QR",
        type: "NEW",
        isInternational: p.isInternational ?? false,
        discountAmount: p.discount,
        discountReason: p.discountReason ?? undefined,
        couponCode: p.couponCode,
        patientPhoneNumber: p.patientPhoneNumber,
        patientEmail: p.patientEmail,
        appointmentNotes: p.appointmentNotes,
        reasonForVisit: p.reasonForVisit,
        symptoms: p.symptoms,
        paymentMode,
        source,
        followUpOfAppointmentId: p.followUpOfAppointmentId,
    };
    Object.keys(request).forEach((k) => request[k] === undefined && delete request[k]);
    return request;
}
function normalizeResponse(raw) {
    const data = raw?.data ?? {};
    return {
        success: Boolean(raw?.success),
        message: raw?.message ?? "",
        data: {
            ...data,
            queuePosition: data.queuePosition ?? data.position,
        },
    };
}
function bookingHeaders(idempotencyKey) {
    return {
        "Content-Type": "application/json",
        ...(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {}),
    };
}
const QmsService = {
    async bookImmediateAppointment(payload, idempotencyKey) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.post("/qms-appointments/immediate/book", toMedosBookingRequest(payload), { headers: bookingHeaders(idempotencyKey) });
        return normalizeResponse(res.data);
    },
    async bookPreAppointment(payload, idempotencyKey) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.post("/qms-appointments/pre/book", toMedosBookingRequest(payload), { headers: bookingHeaders(idempotencyKey) });
        return normalizeResponse(res.data);
    },
    async bookAppointment(payload, idempotencyKey) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const appointmentDate = new Date(payload.appointmentDate);
        appointmentDate.setHours(0, 0, 0, 0);
        const isToday = appointmentDate.getTime() === today.getTime();
        return isToday
            ? this.bookImmediateAppointment(payload, idempotencyKey)
            : this.bookPreAppointment(payload, idempotencyKey);
    },
};
export { QmsService, toMedosBookingRequest };
